<template>
  <transition name="slideTop">
    <div
      v-if="visibility"
      id="sp-notification"
      class="sp-notification"
      :class="type"
      @click="handleClick"
    >
      <div :class="{ 'pointer-cursor': params.link }" v-html="$t(message, params)"/>
      <div
        v-if="closable"
        class="close"
        @click="close"
      >
        <i class="fa fa-times" aria-hidden="true"/>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapStores } from 'pinia';
import { useNotifierStore } from '@/stores/notifier';

export default {
  data() {
    return {
      app: document.getElementById('app'),
    };
  },
  computed: {
    ...mapStores(useNotifierStore),
    visibility() {
      return this.notifierStore.visibility;
    },
    message: {
      cache: false,
      get() {
        return this.notifierStore.message;
      },
    },
    params: {
      cache: false,
      get() {
        return this.notifierStore.params;
      },
    },
    closable() {
      return this.notifierStore.closable;
    },
    type() {
      return this.notifierStore.type;
    },
  },
  methods: {
    handleClick() {
      if (this.params.link) {
        this.$router.push(this.params.link);
      }
    },
    close() {
      this.app.classList.remove('sp-notif-visible');
      this.notifierStore.close({ manually: true });
    },
  },
};
</script>

<style lang="css">
</style>
